module.exports = __webpack_public_path__ + "static/media/2.07ab2193.jpg";